import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader } from "@/components/ui-helpers";
import { Search, ChevronRight, UserRound } from "lucide-react";
import { initials } from "@/mobile/mobileUtils";

export default function MobileClients() {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [clients, setClients] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/clients${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setClients(r.data || [])).catch(() => setClients([]));
    }, q ? 300 : 0);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="p-4 space-y-4" data-testid="mobile-clients">
      <h1 className="font-head font-extrabold text-xl text-slate-900">Clients</h1>
      <div className="relative">
        <Search className="h-4 w-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
        <input data-testid="clients-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, email, phone, UCI, passport"
          className="w-full pl-10 pr-4 py-3 rounded-2xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white" />
      </div>

      {!clients ? <Loader /> : (
        <div className="space-y-2">
          {clients.length === 0 && <div className="text-center py-12 text-slate-400"><UserRound className="h-8 w-8 mx-auto mb-2" /><div className="text-sm">{q ? "No matching clients." : "No clients yet."}</div></div>}
          {clients.map((c) => (
            <button key={c.id} onClick={() => nav(`/m/clients/${c.id}`)} data-testid={`client-row-${c.id}`}
              className="w-full bg-white rounded-2xl p-3.5 border border-slate-100 flex items-center gap-3 text-left active:scale-[0.99] transition-transform">
              <div className="h-11 w-11 rounded-full bg-primary/10 text-primary font-bold text-sm flex items-center justify-center shrink-0">{initials(c.full_name)}</div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-slate-800 truncate">{c.full_name}</div>
                <div className="text-xs text-slate-400 truncate">{c.email || c.phone || c.uci || "—"}</div>
              </div>
              <ChevronRight className="h-4 w-4 text-slate-300 shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
